/**
 * A generic formatter function to extend and use in different scenarios.
 *
 * Can create exported formatters based on different permutations of options.
 */
export const numberFormatter = (options) => {
    let { prefix = '', suffix = '', delimiter = false, minimumFractionDigits = 2, maximumFractionDigits = 2, transformer, } = options ?? {};
    maximumFractionDigits =
        minimumFractionDigits > maximumFractionDigits ? minimumFractionDigits : maximumFractionDigits;
    return (params) => {
        let val = params?.value;
        // Parse phase - parse to an actual number type
        if (!['string', 'number'].includes(typeof val)) {
            return '';
        }
        // Check string value
        if (typeof val === 'string') {
            if (!val.trim() || isNaN(Number(val))) {
                return '';
            }
            val = Number(val);
        }
        // Pre format phase - modify actual number
        if (transformer) {
            val = transformer(val);
        }
        // Format phase - format number as string
        val = delimiter
            ? val.toLocaleString(undefined, {
                minimumFractionDigits,
                maximumFractionDigits,
            })
            : val.toFixed(maximumFractionDigits);
        return `${prefix}${val}${suffix}`;
    };
};
